import { toast } from "react-toastify";
import { COUNTRY_INDIA, ORDER_EXECUTION_TYPE, ORDER_STATE_TYPE } from "./key_helper";
import { OZUYS_PAYMENT_URL, PAYMENT_BASE_URL } from "./constant";
// Function for get user unqiw key forom the localstorage 
export const getUserUniqueKey = () => {
    return localStorage.getItem('fx_user_unique_key');
};
// Function For Get Current Date 
export const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
// Function For Get Date Before 30 Days 
export const getDateBefore30Days = () => {
    const today = new Date();
    today.setDate(today.getDate() - 30); // Subtract 30 days from the current date
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
//Function to gt Current Date and time For export file name
export function getYMDHMSFormat() {
    const date = new Date();
    // Convert to Indian Standard Time (IST)
    const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    // Format date as "yyyyMMdd"
    const year = istDate.getFullYear();
    const month = (istDate.getMonth() + 1).toString().padStart(2, "0");
    const day = istDate.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}${month}${day}`;
    // Format time as "hhmmss" in 24-hour format
    const hours = istDate.getHours().toString().padStart(2, "0");
    const minutes = istDate.getMinutes().toString().padStart(2, "0");
    const seconds = istDate.getSeconds().toString().padStart(2, "0");
    const formattedTime = `${hours}${minutes}${seconds}`;
    // Combine date and time with an underscore separator
    return `${formattedDate}_${formattedTime}`;
}


export const formatStanderdTimeString = (inputTime) => {
    if (!inputTime) return "";
    const inputDate = new Date(inputTime);

    // Check if inputDate is a valid date
    if (!isNaN(inputDate.getTime())) {
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
        const day = inputDate.getDate().toString().padStart(2, "0");
        const hours = inputDate.getHours().toString().padStart(2, "0");
        const minutes = inputDate.getMinutes().toString().padStart(2, "0");
        const seconds = inputDate.getSeconds().toString().padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
        // If inputTime is not a valid date, return it as is (assumed to be in "hh:mm:ss" format)
        return inputTime;
    }
};
export const formatStanderdDateString = (inputTime) => {
    if (!inputTime) return "";
    const inputDate = new Date(inputTime);

    // Check if inputDate is a valid date
    if (!isNaN(inputDate.getTime())) {
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
        const day = inputDate.getDate().toString().padStart(2, "0");

        return `${year}-${month}-${day} `;
    } else {
        // If inputTime is not a valid date, return it as is (assumed to be in "hh:mm:ss" format)
        return inputTime;
    }
};

//Copy To clipboard function
export const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        // Use the modern Clipboard API if available
        navigator.clipboard.writeText(text).then(() => {
            toast.success("Copied successfully!", { hideAfter: 3, });
        })
            .catch((err) => {
                console.log("Failed to copy text with Clipboard API:", err);
            });
    } else {
        // Fallback for older browsers
        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed"; // Avoid scrolling to the bottom
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            toast.success("Text Copied", { hideAfter: 3, });
        } catch (err) {
            console.error("Fallback: Unable to copy text", err);
        }
    }
};

// Function to get the capitalized first letter of the fullname
export const getFirstLetterCapitalized = (name) => {
    if (!name) return "";
    const trimmedName = name.trimStart(); // Remove leading spaces
    return trimmedName.charAt(0).toUpperCase();
};
export const handleSearchSortData = (
    data,
    searchValue,
    searchFields,
    selectedSortOption,
    sortOrder
) => {
    if (!data) return [];

    let filteredData = [...data];

    // --- Search ---
    if (searchValue) {
        const lowercasedSearch = searchValue.toLowerCase();
        filteredData = filteredData.filter((item) =>
            searchFields?.some((field) =>
                item[field]?.toLowerCase().includes(lowercasedSearch)
            )
        );
    }

    // --- Sort ---
    if (selectedSortOption) {
        const field = selectedSortOption.value;

        filteredData.sort((a, b) => {
            // Custom logic to extract values from nested structure
            const getValue = (obj) => {
                if (field in obj) return obj[field];
                if (obj.account_info && field in obj.account_info) return obj.account_info[field];
                return undefined;
            };

            const valueA = getValue(a);
            const valueB = getValue(b);

            // Handle strings vs numbers
            if (typeof valueA === "string" && typeof valueB === "string") {
                return sortOrder === "ascending"
                    ? valueA.localeCompare(valueB)
                    : valueB.localeCompare(valueA);
            } else {
                return sortOrder === "ascending"
                    ? (valueA ?? 0) - (valueB ?? 0)
                    : (valueB ?? 0) - (valueA ?? 0);
            }
        });
    }

    return filteredData;
};
// Utility function to format date to display format (local time)
export function formatDisplayDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0"); // local day
    const month = new Intl.DateTimeFormat('en-GB', { month: 'short' }).format(date); // local month
    const year = date.getFullYear(); // local year

    return `${day} ${month} ${year}`;
}

export const getOrderTypeName = (type) => {
    return ORDER_EXECUTION_TYPE[type] || 'Unknown'; // Return 'Unknown' if type is not found
}

export const getOrderStateName = (type) => {
    return ORDER_STATE_TYPE[type] || 'Unknown'; // Return 'Unknown' if type is not found
}

export function generatePaymentLink(user_id, country, amount) {
    const baseUrl = country === COUNTRY_INDIA ? OZUYS_PAYMENT_URL : PAYMENT_BASE_URL;
    const params = new URLSearchParams({ user_id, country, amount });
    return `${baseUrl}?${params.toString()}`;
}

export const trimValues = (input) => {
    if (typeof input === "string") {
        return input?.trim();
    }

    if (typeof input === "object" && input !== null) {
        const trimmedObj = {};
        for (const key in input) {
            if (typeof input[key] === "string") {
                trimmedObj[key] = input[key]?.trim();
            } else {
                trimmedObj[key] = input[key];
            }
        }
        return trimmedObj;
    }

    // If not string or object, return as is
    return input;
};

// function for format domain name
export function formattedDomainName(url) {
    // Remove protocol (http://, https://)
    let domain = url?.replace(/(^\w+:|^)\/\//, '');
    // Remove 'www.' if it exists
    if (domain?.startsWith('www.')) {
        domain = domain?.substring(4);
    }
    // Extract only the domain (removing path, query string, etc.)
    domain = domain?.split('/')[0].split('?')[0];
    domain = domain?.replace(/\./g, '_'); // Replace dots with underscores
    return domain;
}
export const getCssVariable = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

// Function to extract the main domain from a URL
export function extractMainDomain(url) {
    if (!url) return "";

    // Remove protocol (http, https, etc.)
    let ret_name = url.replace(/(^\w+:|^)\/\//, '');
    // Remove www. if present
    if (ret_name.startsWith('www.')) {
        ret_name = ret_name.substring(4);
    }
    // Remove path and query params
    ret_name = ret_name.split('/')[0].split('?')[0];
    return ret_name;
}
export function getDomainName(need_flat = false) {
    const base_url = window.location.origin;
    let final_url = base_url;
    if (
        base_url.includes("localhost") ||
        base_url.includes("192.168") ||
        base_url.includes("127.0.0.1")
    ) {
        final_url = "https://algodeltafx.com";
    }

    if (need_flat) {
        return extractMainDomain(final_url).replaceAll(".", "_");
    }
    return final_url;
}
// Function to get primary color from the root 
export const getPrimaryColor = () => {
    return getComputedStyle(document.documentElement)
        .getPropertyValue('--color-primary')
        .trim()
};
export function isAlgoDeltaFxDomain(domain) {
    if (!domain) return false;

    const normalized = domain
        .replace(/(^\w+:|^)\/\//, '')     // remove protocol
        .replace(/^www\./, '')            // remove 'www.'
        .split('/')[0]                    // remove path
        .split('?')[0]                    // remove query
        .toLowerCase();
    return normalized.includes("algodeltafx");
}